import { Configuration, PopupRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: "ea7877e7-bcd7-4e4e-b530-0e993e93ccd9",
    authority: "https://login.microsoftonline.com/619800fc-aad5-437c-8447-2710e029771e",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const loginRequest: PopupRequest = {
  scopes: ["openid", "profile", "email"],
};
